<!--
 * @Author: p_fy
 * @Date: 2019-07-18 17:22:46
 * @LastEditors: p_fy
 * @LastEditTime: 2019-07-18 20:53:36
 * @Description: 普通仓库供给详情信息。
 -->
<!--  详情显示页面  -->
<template>
  <div class="supply-item-details">
    <div class="base-info">
      <div>基本信息</div>
      <ul>
        <li :title="supply.storageLocationLabel">
          <span>库房位置</span> {{ supply.storageLocationLabel }}
        </li>
        <li :title="`${supply.expectPrice}元/m²/天`">
          <span>租金</span> {{ supply.expectPrice }}元/m²/天
        </li>
        <li :title="supply.warehouseTypeLabel">
          <span>仓库类型</span> {{ supply.warehouseTypeLabel }}
        </li>
        <li :title="supply.detailedLocation">
          <span>详细地址</span> {{ supply.detailedLocation }}
        </li>
        <li :title="supply.leaseTermLabel">
          <span>起租年限</span> {{ supply.leaseTermLabel }}
        </li>
        <li :title="supply.companyName">
          <span>公司名称</span> {{ supply.companyName }}
        </li>
        <li :title="supply.leaseTime">
          <span>起租日期</span> {{ supply.leaseTime }}
        </li>
        <li :title="supply.fireQualificationLabel">
          <span>消防资质</span> {{ supply.fireQualificationLabel }}
        </li>
        <li :title="`${supply.lettableArea}m²`">
          <span>起租面积</span> {{ supply.lettableArea }}m²
        </li>
        <li :title="`${supply.coveredArea}m²`">
          <span>建筑面积</span> {{ supply.coveredArea }}m²
        </li>
        <li :title="`${supply.rentableArea}m²`">
          <span>可租用面积</span> {{ supply.rentableArea }}m²
        </li>
        <li :title="supply.landingPlatformLabel">
          <span>卸货平台</span> {{ supply.landingPlatformLabel }}
        </li>
        <li :title="supply.floorTextureLabel">
          <span>地坪质地</span> {{ supply.floorTextureLabel }}
        </li>
        <li :title="`${supply.floorWeight}吨`">
          <span>地坪承重</span> {{ supply.floorWeight }}吨
        </li>
        <li :title="supply.storeEquipmentLabel">
          <span>库内设备</span> {{ supply.storeEquipmentLabel }}
        </li>
        <li :title="supply.appointmentDate">
          <span>预约时间</span> {{ supply.appointmentTime }}
        </li>
        <li :title="supply.storageTypeLabel">
          <span>货物类型</span> {{ supply.storageTypeLabel }}
        </li>
      </ul>
    </div>
    <div class="contact-info">
      <div>联系人</div>
      <ul>
        <li>
          <span>联系人</span> {{ supply.linkMan }}
        </li>
        <li>
          <span>联系电话</span> {{ supply.telephone }}
        </li>
      </ul>
    </div>
    <div class="imgs-info">
      <div>图片</div>
      <ul v-if="storageUrl(supply)" v-viewer>
        <li v-for="(item , index) in storageUrl(supply)" :key="index">
          <img :src="item | getImg" onerror="this.src='https://graph.baidu.com/thumb/v3/3277128572,4129418819.jpg';this.onerror=null;">
        </li>
      </ul>
      <div>备注</div>
      <span>{{ supply.storageRecommend }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'StoreSupplyInfo',
  props: {
    supply: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    storageUrl(supply) { // 图片回调
      return (supply) => {
        if (supply.storageUrl == null || supply.storageUrl == '') {
          return false
        }
        return supply.storageUrl.split(',').filter(n => n) // 数组去空
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$perfix: "supply-item";
$main-color: rgb(190, 35, 22);
@keyframes show {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .#{$perfix}-details {
    position: relative;
    width: 100%;
    background-color: rgb(250, 251, 255);
    transition: all 0.8s ease-in-out;
    z-index: -1;
    padding-bottom: 16px;
    display: block;
    animation: show 0.8s ease-in-out;
    clip: rect(0 auto 0 0);
    > div {
      padding: 16px 16px;
      width: calc(100% - 32px);
      font-size: 14px;
      border-bottom: 1px solid #ebeef5;
      &:last-child {
        border-bottom: none !important;
      }

      ul {
        li {
          span:after {
            content: " : ";
          }
        }
      }

      > div {
        font-size: 15px;
        font-weight: bold;
        color: $main-color;
        margin-bottom: 24px;
      }
      &.base-info {
        ul {
          columns: 3;
          column-width: 25%;
          column-gap: 16px;
          > li {
            height: 16px;
            line-height: 16px;
            padding: 7px 0px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
      &.contact-info {
        ul {
          width: 50%;
          columns: 2;
          column-width: 25%;
          column-gap: 16px;
          > li {
            height: 16px;
            line-height: 16px;
            padding: 7px 0px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }

      &.imgs-info {
        // word-wrap: break-word;
        word-break: break-all;
        ul {
          display: inline-block;
          li {
            float: left;
            margin-right: 24px;
            margin-bottom: 12px;
            &:last-child {
              margin-right: 0px !important;
            }
            img {
              height: 124px;
              width: 136px;
            }
          }
        }
      }
    }
  }
</style>
